import request from '../utils/request.js'

export async function loginUser(obj) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: obj
  })
}
export async function registerCode(obj) {
  return request({
    url: '/auth/send-register-code',
    method: 'post',
    data: obj
  })
}
export async function forgotPassword(obj) {
  return request({
    url: '/auth/forgot-password',
    method: 'post',
    data: obj
  })
}
export async function registerUser(obj) {
  return request({
    url: '/auth/register',
    method: 'post',
    data: obj
  })
}

export async function logoutUser() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export async function resetPassword(obj) {
  return request({
    url: '/auth/reset-password',
    method: 'post',
    data: obj
  })
}



export async function getUserProfile() {
  return request({
    url: '/user/profile',
    method: 'get'
  })
}

export async function putUserProfile(obj) {
  return request({
    url: '/user/profile',
    method: 'put',
    data: obj
  })
}
